import { HfsAction, HfsActionEnum } from 'fleet-data-model';
import type { AssetListItem } from '@fleet-bffs/api-contract';

export const getAssetAction = (
  asset: AssetListItem,
  hfsAction: HfsActionEnum
): HfsAction | undefined => asset?.actions?.find((item) => item.hfsAction === hfsAction);

export const getIsHfsActionsUpdateRelevant = (
  eventTimestampISOString: string,
  previousTimestampISOString: string | undefined
): boolean => {
  if (previousTimestampISOString === undefined) {
    return true;
  }
  return new Date(eventTimestampISOString) >= new Date(previousTimestampISOString);
};
